import styled from 'styled-components'

export const OptionDetailsSelectContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;

  padding: 23px 0;

  border-bottom: 1px solid #e2e2e2;

  > p {
    min-width: 40%;
    width: 40%;

    padding-right: 5%;
  }
`

export const OptionDetailsSelectOtherContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const OptionDetailsSelectStatusWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  width: 100%;

  svg {
    cursor: pointer;
    margin-left: 5px;
  }

  div {
    margin-top: 0;
    max-width: none;
  }
`
